<template>
	<div>
		<el-form
			ref="form"
			:model="info"
			status-icon
			label-position="right"
			label-width="6rem"
			size="mini"
			v-loading="loadings.main"
			@submit.native.prevent
			class="row"
			:rules="rules"
			v-if="hasGetTableDataModel"
		>
			<div class="col-md-6">
				<div class="form-group" v-loading="loadings.customer">
					<div class="form-group-title">客户信息</div>
					<div class="row">
						<div :class="'col-md-'+(key.col?key.col:6)" v-for="(key,index) in userFields" :key="index">
							<el-form-item :label="dataModels['Order'][key.name].show_name" :prop="key.name">
								<field-editor
									v-model="info[key.name]"
									:field-info="dataModels['Order'][key.name]"
									:width="key.width"
									:params="key.params ? key.params :{}"
									@change="handleOrderEdited(key)"
								></field-editor>
							</el-form-item>
						</div>
						<div class="col-md-12">
							<hr />
							<div class="d-flex clearfix">
								<label class="el-form-item__label" style="width: 6rem;">收件人信息</label>
							</div>
							<field-editor
								v-model="info[addressField.name]"
								:field-info="dataModels['Order'][addressField.name]"
								:width="addressField.width"
								:params="addressField.params ? addressField.params :{}"
								@change="handleOrderEdited(addressField)"
							></field-editor>
						</div>
					</div>
				</div>
				<div class="form-group" v-if="info.type.index!=30">
					<div class="form-group-title">金额信息</div>
					<div class="row">
						<div :class="'col-md-'+(key.col?key.col:6)" v-for="(key,index) in payFields" :key="index">
							<span v-if="key.name=='null' || (key.isHiddenWhenNull && !info[key.name])"></span>
							<el-form-item :label="dataModels['Order'][key.name].show_name" :prop="key.name" v-else>
								<field-show
									record-model="Order"
									:field-info="dataModels['Order'][key.name]"
									:value="info[key.name]"
									:field-key="key"
									:params="key.params"
									v-if="key.isOnlyShow"
								></field-show>
								<field-editor
									v-else
									v-model="info[key.name]"
									:field-info="dataModels['Order'][key.name]"
									:width="key.width"
									:params="key.params ? key.params :{}"
									@change="handleOrderEdited(key)"
                  @input="change($event)"
								></field-editor>
							</el-form-item>
						</div>
					</div>
				</div>
			</div>
			<div class="col-md-6">
				<div class="form-group">
					<div class="form-group-title">订单信息</div>
					<div class="row">
						<div :class="'col-md-'+(key.col?key.col:6)" v-for="(key,index) in orderFields" :key="index">
							<span v-if="key.name=='null'"></span>

							<el-form-item :label="dataModels['Order'][key.name].show_name" :prop="key.name" v-else>
								<field-editor
									v-model="info[key.name]"
									:field-info="dataModels['Order'][key.name]"
									:width="key.width"
									:params="key.params ? key.params :{}"
									@change="handleOrderEdited(key)"
								></field-editor>
							</el-form-item>
						</div>
						<div class="col-md-12">
							<el-form-item label="订单类型">
								<el-radio-group v-model="info.type.index" size="mini">
									<el-radio-button :label="0">订单</el-radio-button>
								</el-radio-group>
							</el-form-item>
						</div>
					</div>
				</div>
			</div>
		</el-form>
		<div class>
			<hr />
			<div class="dl total-show">
				<span class="dt">总数量</span>
				<span class="dd">{{total_amount}}</span>
				<span class="dt">总价格</span>
				<span class="dd">{{total_price}}</span>
			</div>
		</div>
		<reserve-order
				v-if="hasGetTableDataModel && info.customer._id"
				v-model="info.orderItems"
				:item-data = "info.orderItems"
				@select-change = "selectChangeHandel"
		></reserve-order>
		<reserve-item
				:showSelect = true
				class="mt-3"
				@insert="onInsertItems($event)"
				:customer-id="info.customer._id"
				v-if="hasGetTableDataModel && info.customer._id"
				@selectChange = "selectChangeHandel"
		></reserve-item>
		<hr />
		<div class="btn-holder text-center" v-loading="loadings.main">
			<el-button size type="success" :disabled="info.orderItems.length==0" @click="handlerPost('edit')">保存</el-button>
		</div>
	</div>
</template>

<script>
import Order from "@/mixinsApp/Order.js";
import TxOp from "@/mixinsApp/TxOp.js";
import { mapState, mapGetters, mapMutations } from "vuex";
import ReserveItem from "@/views/Reserve/Index.vue";
import ReserveOrder from "@/views/Reserve/subs/OrderItems.vue"

export default {
	components: {ReserveItem,ReserveOrder},
	mixins: [Order, TxOp],
	config: {
		adminFilter: [
			{
				k: "is_leave",
				t: "bool",
				v: 0,
			},
			{
				k: "is_saler",
				t: "bool",
				v: 1,
			},
		],
    customerFilter: [
      {
        k: "type",
        t: "int",
        lge : ">=",
        v: 0,
      }
    ],
	},
	data() {
		return {
			loadings: {
				main: false,
				create: false,
				insert: false,
				customer: false,
			},

			total_price_or:0,
			customerInfo: {},
			info: {
				customer: {
					_id: "",
				},
				express_type: {
					index: 0,
				},
				address: {
					_id: "",
					name: "",
					street: "",
					phone: "",
					nation: {
						index: "852",
						name: "香港",
					},
				},
				send_from_type: {
					index: 0,
				},
				pay_method: {
					index: 1,
				},
				has_payed: false,
				express_fee: 0,
				discount: 0,
				desc: "",
				items: [],
				orderItems:[],
				type: {
					index: 0,
					name: "订单",
				},
			},
			addressField: {
				name: "address",
				params: {
					needFilter: true,
					kvFilter: [],
					allowCreate: false,
					isFreeMode: true,
				},
				nameFields: ["province", "address"],
				width: "100%",
				col: 6,
			},
			defaultValue: {
				customer: {
					name: "",
					_id: "",
					agent_level: 0,
					type: 1,
				},
				address: {
					_id: "",
					name: "",
					street: "",
					phone: "",
				},
			},
			payFields: [
				{
					name: "pay_method",
				},

				{
					name: "express_fee",
				},
				{
					name: "discount",
				},
				{
					name: "express_fee_typ",
					isOnlyShow: true,
					isHiddenWhenNull: true,
				},
				{
					name: "est_express_fee",
					isOnlyShow: true,
					isHiddenWhenNull: true,
				},
				{
					name: "est_clearance_fee",
					isOnlyShow: true,
					isHiddenWhenNull: true,
				},
			],
		};
	},
	computed: {
		...mapState(["userPrivilegeMapping","configs"]),
		isCheckLessThanHolder() {
			// return true;
			if (this.userPrivilegeMapping[42]) {
				return false;
			} else {
				return true;
			}
		},
		fields() {
			return this.userFields.concat(this.orderFields).concat(this.payFields);
		},
		userFields() {
			const fields = {
				customer: {
					name: "customer",
					params: {
						type: this.configs['Order.front.userType'] || 'User',
						tipShow: "balance",
						tipShowName: "当前余额",
						allowCreate: true,
            kvFilter: this.customerFilter,
					},
					width: "100%",
				},
				express_type: {
					name: "express_type",
					params: {
						isRadio: true,
					},
				},
				send_from_type: {
					name: "send_from_type",
					width: "100%",
				},
				warehouse: {
					name: "warehouse",
				},
				has_help_clearance: {
					name: "has_help_clearance",
				},
			};
			// if (this.info.customer._id) {
			// 	this.addressField.params.kvFilter = [
			// 		{ k: "customer", t: "_id", v: this.info.customer._id },
			// 	];
			// }
			//10 => '代发货',
			// 20 => '自取',
			if (this.info.express_type.index == 10) {
				delete fields.warehouse;
				// this.addressField.params.isFreeMode = true;
			} else if (this.info.express_type.index == 20) {
				// delete fields.address;
				delete fields.send_from_type;
			} else {
				delete fields.warehouse;
				// fields.address.params.isFreeMode = false;

				// delete fields.receiver;
				// delete fields.receiver_phone;
				// delete fields.receiver_street;
			}
			return Object.values(fields);
		},
		orderFields() {
			const fields = {
				// saler: {
				// 	name: "saler",
				// 	params: {
				// 		allowCreate: false,
				// 		notUseMeAsDefault: true,
				// 		kvFilter: this.adminFilter,
				// 	},
				// },

				desc: {
					name: "desc",
					width: "100%",
					col: 12,
				},
				primary_img: {
					name: "primary_img",
					width: "100%",
					params: {
						// isFlat: true
					},
					col: 12,
				},
			};
			return Object.values(fields);
		},

		total_amount() {
			let total_amount = 0;
			for (let k in this.info.orderItems) {
				total_amount += parseFloat(this.info.orderItems[k].order_amount);
			}
			return total_amount;
		},

		total_price() {
			let total_price = 0;

			for (let k in this.info.orderItems) {
				total_price += parseFloat(this.info.orderItems[k].order_amount * this.info.orderItems[k].price_per);
			}
			// this.total_price_or = total_price

			return parseFloat((total_price - this.info.discount + this.info.express_fee));
		},
	},

	props: {
		recordId: {
			type: String,
			default: "",
		},
		value: {
			type: Object,
			default: null,
		},
	},
	methods: {
		handlerPost() {
			if (this.info.orderItems.length <= 0) {
				this.$message.error("尚未录入货单");
				return;
			}
			this.$refs["form"].validate(valid => {
				if (!valid) {
					this.$message.error("请检查输入");
					return false;
				}
					this.$confirm("是否继续?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
							.then(() => {
								this._doPost();
							})
							.catch(() => {
								this.$message({
									type: "info",
									message: "已取消",
								});
							});
			});
		},

    change(e){
      this.$forceUpdate()
    },
		handleOrderEdited(key) {
    },
		doResetAll() {
			// this.initInfo();
		},
		_doPost(type) {
			this.loadings.main = true;
			let data = JSON.parse(JSON.stringify(this.info));
			data.customer = {
				_id: data.customer._id,
			};
			delete data.logs;
			data.items = data.items.map(val => {
				return {
					_id: val._id,
					item: val.item,
					amount: val.amount,
					price_per: val.price_per,
					total_price: val.total_price,
					product_color: {
						_id: val.product_color._id,
					},
				};
			});
			this.$axios
				.post(`/reserve/do_create_order`, data)
				.then(json => {
					this.loadings.main = false;

					this.$message.success("成功");
						this.$router.push({
							name: "Order-Info",
							params: {
								id: json.data.info._id,
								tab: "info",
							},
						});
				})
				.catch(json => {
					this.loadings.main = false;
					this.$message.error(json.data.msg);
				});
		},
		getCustomerInfo(_id) {
			//说不要
			// if (this.info.express_type.index != 0) {
			// 	this.info.address.name = "";
			// 	this.info.address.street = "";
			// 	this.info.address.phone = "";
			// 	return;
			// }
			// this.loadings.customer = true;
			// this.$axios.get(`/curd/info/customer/${_id}`).then(json => {
			// 	this.loadings.customer = false;
			// 	this.info.address.name = json.data.info.name;
			// 	this.info.address.street = json.data.info.street;
			// 	this.info.address.phone = json.data.info.phone;
			// });
		},

		selectChangeHandel(val){
			for(let i in val){
				console.log("val[i]['order_amount']",typeof(val[i]['order_amount']))
				val[i]['total_price'] = val[i]['price_per'] * val[i]['order_amount']
			}
      this.info.orderItems.push(...val)
      this.info.orderItems = this.removeDuplicatesBy_Id(this.info.orderItems)
		},

    removeDuplicatesBy_Id(array) {
      const uniqueArray = array.reduce((acc, current) => {
        // 检查累加器数组中是否已有相同_id的元素
        const exists = acc.some((item) => item._id === current._id);
        // 如果没有，则添加到累加器数组中
        if (!exists) {
          acc.push(current);
        }
        return acc;
      }, []); // 初始化累加器为数组

      return uniqueArray;
    }

	},
	watch: {
		value: {
			handler(val) {
				if (val) {
					this.info = Object.assign({}, val);
				}
			},
			immediate: true,
		},
		"info.customer._id": {
			handler(_id) {
				if (_id) {
					this.getCustomerInfo(_id);
				}
			},
			immediate: true,
		},
		"info.express_type.index": {
			handler(val) {
				if (val == 0) {
					this.getCustomerInfo(this.info.customer._id);
				}
			},
		},
		// itemData(val){
		// 	console.log("过来了", val)
		// 	this.itemData = val
		// }
	},
};
</script>
<style>
.el-radio-button--mini .el-radio-button__inner {
	padding: 7px 7px;
}
</style>
